import * as React from 'react';

import { EntityActions, EntityType } from 'common/entity';

import { AppState } from 'common/models/AppState';
import { Product } from 'common/api/models/Product';
import { ProductsDialog } from './ProductsDialog';
import { ProductsTable } from './ProductsTable';
import { Page } from 'common/components/layout/Page/Page';
import * as acl from 'common/utils/acl';
import { Card } from '../../common/components/Card';
import { Tag } from 'common/api/models/Tag';
import { TagApi } from '../../common/api/resources/TagApi';
import { toApiError } from 'common/utils/api';
export interface ProductsProps {
  appState: AppState;
  entityActions: EntityActions;
}
export interface ProductsState {
  error?: string;
  tags: Tag[];
  editProduct?: Product;
  reloadAt: Date;
  isLoading: boolean;
}
const NEW_PRODUCT: Product = {};

export class Products extends React.Component<ProductsProps, ProductsState> {
  state: ProductsState = { reloadAt: new Date(), tags: [], isLoading: true };

  handleAdd = () => {
    this.setState({ editProduct: NEW_PRODUCT });
  };

  handleEdit = (product: Product) => {
    this.setState({ editProduct: product });
  };

  handleCancelDialog = () => {
    this.setState({ editProduct: undefined });
  };

  handleSaveDialog = (id: string) => {
    this.props.entityActions.refetch(EntityType.PRODUCT, id);
    this.setState({ editProduct: undefined, reloadAt: new Date() });
  };

  componentDidMount() {
    this.reload();
  }

  reload() {
    if (this.state.tags.length === 0) {
      this.setState({ isLoading: true });
      TagApi.findTags({ type: 'BADGE' }).then(
        results => {
          this.setState({
            tags: results.data,
            error: undefined,
            isLoading: false,
          });
        },
        err => {
          this.setState({ error: toApiError(err), isLoading: false });
        }
      );
    }
  }

  render() {
    return (
      <Page
        title="Products"
        primaryAction={{
          shouldRender: acl.isStaff(this.props.appState.user!),
          onClick: this.handleAdd,
          label: 'Add Product',
        }}
      >
        {this.state.error && (
          <div className="alert alert-danger" style={{ marginTop: 20 }}>
            {this.state.error}
          </div>
        )}
        <Card responsive={true}>
          <ProductsTable
            appState={this.props.appState}
            entityActions={this.props.entityActions}
            reloadAt={this.state.reloadAt}
            onEdit={this.handleEdit}
          />
        </Card>
        <ProductsDialog
          product={this.state.editProduct}
          tags={this.state.tags}
          onSave={this.handleSaveDialog}
          onCancel={this.handleCancelDialog}
        />
      </Page>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Products/Products.tsx